module.exports = __webpack_public_path__ + "img/skiing004.df769d78.jpg";